import { useCallback } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import { useFilteredViewContextInput } from '@atlassian/jira-business-filters/src/controllers/default-query-input/index.tsx';
import { useStartDateField } from '@atlassian/jira-router-resources-business-configuration/src/index.tsx';
import { QUERY as CALENDAR_ITEM_QUERY } from '../../services/calendar-view-items/gql.tsx';
import type { UseCalendarItemsRequest } from '../../services/calendar-view-items/types.tsx';
import { toQuery } from '../../services/calendar-view-items/utils.tsx';
import type { JWMCalendarInlineCreateIssue_createJiraBusinessIssue_item as Issue } from '../../services/create-issue/__generated_apollo__/JWMCalendarInlineCreateIssue.ts';

export const useCacheActions = () => {
	const client = useApolloClient();
	const { data: startDateField } = useStartDateField();
	const { quickFiltersJql } = useFilteredViewContextInput({ view: 'calendar' });

	const startDateFieldId = startDateField?.id ? startDateField.id.split('_')[1] : null;

	const addToCache = useCallback(
		(request: UseCalendarItemsRequest, newCalendarIssue: Issue) => {
			const variables = {
				jql: toQuery(request, quickFiltersJql, startDateFieldId),
			};

			const cacheData = client.readQuery({
				query: CALENDAR_ITEM_QUERY,
				variables,
			});

			client.writeQuery({
				query: CALENDAR_ITEM_QUERY,
				variables,
				data: {
					jira: {
						...cacheData.jira,
						list: {
							...cacheData.jira.list,
							edges: [
								...cacheData.jira.list.edges,
								{
									node: newCalendarIssue,
									__typename: 'JiraWorkManagementViewItemEdge',
								},
							],
						},
					},
				},
			});
		},
		[client, quickFiltersJql, startDateFieldId],
	);

	return { addToCache };
};
